import React from 'react';

const SaleBanner: React.FC = () => {
  return (
    <section className="relative z-10 bg-[#b05e2c] px-4 py-4 text-white sm:px-6">
      <div className="mx-auto flex max-w-6xl flex-col items-center justify-center gap-2 text-center sm:flex-row sm:gap-4">
        <span className="rounded-full bg-[#f3dfb7] px-4 py-1 text-sm font-semibold uppercase tracking-[0.2em] text-[#7c3f1d]">
           Compost is sold out
        </span>
        <p className="text-base font-medium sm:text-lg">
         Thanks for a great season! Fall compost orders will begin at the end of September.
        </p>
      </div>
    </section>
  );
};

export default SaleBanner;